<template>
  <div class="loginbgBox">
    <div class="logincontent">
      <div class="logo-box"></div>
      <div class="right-box">
        <div class="form-box">
          <div class="form-title">
            <img class="logo" src="@static/images/login/JCHOME@2x.png" alt="" srcset="" />
          </div>
          <div class="item-title">账号</div>
          <div class="ivu-input-wrapper">
            <!-- <i class="icon icon-user"></i> -->
            <img class="icon-logo" src="@static/images/login/logo-ico1.png" alt="" srcset="" />
            <input v-model="formInline.account" placeholder="请输入账号" class="ivu-input" type="text" @keyup.enter="yz" />
          </div>
          <div class="item-title">密码</div>
          <div class="ivu-input-wrapper">
            <!-- <i class="icon icon-password"></i> -->
            <img class="icon-logo" src="@static/images/login/logo-ico2.png" alt="" srcset="" />
            <input v-model="formInline.password" placeholder="请输入密码" class="ivu-input" :type="isSee ? 'text' : 'password'" @keyup.enter="yz" />
            <img src="@static/images/login/eye1.png" class="password-eye" v-if="!isSee" @click="isSee = true" alt />
            <img src="@static/images/login/eye2.png" class="password-eye" v-else @click="isSee = false" alt />
          </div>
          <div class="item-title">验证码</div>
          <div class="ivu-input-wrapper code-input">
            <!-- <i class="icon icon-auth"></i> -->
            <img class="icon-logo" src="@static/images/login/logo-ico3.png" alt="" srcset="" />
            <input v-model="formInline.code" placeholder="请输入验证码" class="ivu-input" type="text" @keyup.enter="yz" />
            <div class="code-wrap">
              <img :src="'/system/info/createCode?t=' + imgTime" class="code-img" @click="resetCode()" />
            </div>
          </div>
          <Button class="login-btn" long type="primary" @click="yz" :loading="loading">登 录</Button>
        </div>
      </div>
    </div>
    <!-- 忘记密码弹窗 -->
    <Modal
      v-model="showForgetTip"
      ok-text="发送验证码"
      title="忘记密码"
      :mask-closable="false"
      @on-ok="confirmForgetCode"
      @on-cancel="cancelForgetCode"
      :loading="$root.$children[0].modalLoading"
      width="500"
    >
      <Form label-position="top" ref="formValidate" :model="formForget" :rules="ruleValidate">
        <FormItem label="您的手机号" prop="mobile">
          <Input size="large" v-model="formForget.mobile" placeholder="请输入手机号"></Input>
        </FormItem>
      </Form>
    </Modal>
    <!-- 重置密码弹窗 -->
    <Modal
      :mask-closable="false"
      v-model="showForget"
      title="重置密码"
      @on-ok="confirmForget"
      @on-cancel="cancelForget"
      :loading="$root.$children[0].modalLoading"
      width="620"
      class="resetPass"
    >
      <Form ref="formValidateReset" :model="formForgetReset" :rules="ruleValidateReset" :label-width="0">
        <FormItem>
          验证码已发送至您的手机:
          <span style="font-weight: bold">{{ formForget.mobile }}</span>
        </FormItem>
        <FormItem prop="code">
          <span class="icon icon-auth preIcon"></span>
          <Input autocomplete size="large" v-model="formForgetReset.code" placeholder="请输入您的验证码"></Input>
          <Button size="large" type="primary" @click="sendCode" :disabled="!!codeTimer">{{ timeTxt }}</Button>
        </FormItem>
        <FormItem prop="password">
          <span class="icon icon-password preIcon"></span>
          <Input size="large" v-model="formForgetReset.password" placeholder="请输入新密码"></Input>
        </FormItem>
        <div>注：新密码长度8-16位，且必须包含大写字母、小写字母、数字、特殊字符中的至少三种</div>
      </Form>
    </Modal>
    <!-- 安全验证、绑定手机号 -->
    <Modal v-model="showPhoneValid" class="phone-valid-box" class-name="vertical-center-modal" width="500">
      <div slot="header">
        <h1 class="phone-valid-title">安全验证</h1>
        <p class="phone-valid-tip">为保障账户安全,请{{ bindPhoneNumber ? '进行身份验证' : '绑定手机号' }}</p>
      </div>
      <div class="phone-code-container">
        <div class="phone-number" v-if="bindPhoneNumber">登录手机号：{{ bindPhoneNumber }}</div>
        <div class="phone-code-box phone-input" v-else>
          <Icon class="icon-phone" type="ios-phone-portrait" />
          <input type="text" v-model="phoneNumber" maxlength="11" placeholder="请输入您的手机号" />
        </div>
        <div class="phone-code-box">
          <img src="../assets/images/icon/org/safe.png" alt />
          <input type="text" v-model="phoneCode" :maxlength="6" placeholder="请输入短信验证码" @keyup.enter="phoneCodeLogin" />
          <span @click="getCode" :class="{ active: codeText != '获取验证码' }">{{ codeText }}</span>
        </div>
        <div class="tip" v-if="!bindPhoneNumber">注：绑定的手机号可用于登录系统</div>
      </div>
      <div slot="footer">
        <Button size="large" @click="showPhoneValid = false">取消</Button>
        <Button type="primary" size="large" @click="phoneCodeLogin" :disabled="phoneCode.length == 0">{{ bindPhoneNumber ? '确定' : '绑定并登录' }}</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
//当前实例组件
export default {
  data: () => ({
    active: false,
    codeTimer: null,
    timeTxt: '点击发送',
    formForget: {
      mobile: ''
    },
    formForgetReset: {
      code: '',
      password: ''
    },
    ruleValidateReset: {
      code: [{ required: true, message: '请输入验证码', trigger: 'blur' }],
      password: [
        { required: true, message: '请输入新密码', trigger: 'blur' },
        {
          trigger: 'blur',
          pattern:
            /^(?![a-zA-Z]+$)(?![A-Z0-9]+$)(?![A-Z\W_!@#$%^&*`~()-+=]+$)(?![a-z0-9]+$)(?![a-z\W_!@#$%^&*`~()-+=]+$)(?![0-9\W_!@#$%^&*`~()-+=]+$)[a-zA-Z0-9\W_!@#$%^&*`~()-+=]{8,16}$/,
          message: '新密码格式不正确'
        }
      ]
    },
    ruleValidate: {
      mobile: [
        { required: true, message: '请输入您的手机号', trigger: 'blur' },
        { pattern: /^1[1023456789]\d{9}$/, message: '请输入正确的手机号' }
      ]
    },
    showForgetTip: false,
    showForget: false,
    imgTime: new Date().getTime(),
    loading: false,
    formInline: {
      account: '',
      password: '',
      code: ''
    },
    showPhoneValid: false, //手机验证(绑定手机号)弹窗
    phoneNumber: '', //输入的手机号
    bindPhoneNumber: '', //已绑定的手机号
    phoneCode: '', //验证码
    codeText: '获取验证码',
    count: 60, //验证码时间倒计时
    timer: '', //验证码时间定时器
    isSee: false //查看密码
  }),
  components: {},
  created() {},
  methods: {
    jumpPage(url) {
      window.open(url, '_blank');
    },
    timerDown() {
      if (this.timer) return;
      let time = 60;
      this.codeTimer = setInterval(() => {
        time--;
        this.timeTxt = '重新发送' + '（' + time + 's）';
        if (time <= 0) {
          clearInterval(this.codeTimer);
          this.codeTimer = null;
          this.timeTxt = '重新发送';
        }
      }, 1000);
    },
    //修改密码
    changePassword() {
      const { code, password } = this.formForgetReset;
      const { mobile } = this.formForget;
      this.$http({
        url: '/system/info/resetPassWordByForget',
        type: 'post',
        data: {
          mobile,
          code,
          password
        }
      }).then(res => {
        this.$Message.success('修改成功');
        this.showForget = false;
      });
    },
    //发送验证码
    sendCode() {
      return this.$http({
        url: '/system/info/sendCodeByForget',
        type: 'get',
        data: {
          mobile: this.formForget.mobile,
          code: this.formForget.code,
          account: this.formForget.account,
          password: this.formForget.password,
          loginType: 2, //
          loginMode: 1
        }
      })
        .then(res => {
          this.timerDown();
          this.$Message.success('发送成功');
          return res.data;
        })
        .catch(e => {
          console.log(e);
          clearInterval(this.codeTimer);
          this.codeTimer = null;
          this.timeTxt = '重新发送';
        });
    },
    //重置密码
    confirmForget() {
      this.$units.notCloseModal(this);
      this.$refs.formValidateReset.validate(valid => {
        if (valid) {
          this.changePassword();
        }
      });
    },
    cancelForget() {
      clearInterval(this.codeTimer);
      this.codeTimer = null;
      this.timeTxt = '重新发送';
    },
    cancelForgetCode() {
      clearInterval(this.codeTimer);
      this.codeTimer = null;
      this.timeTxt = '重新发送';
    },
    //确认手机号
    confirmForgetCode() {
      this.$units.notCloseModal(this);
      this.$refs.formValidate.validate(valid => {
        if (valid) {
          //  alert(true)
          //显示重置密码弹窗
          this.sendCode().then(res => {
            if (res) {
              this.showForget = true;
              this.$refs.formValidateReset.resetFields();
              this.showForgetTip = false;
            }
          });
        }
      });
    },
    //显示手机号弹窗
    toShowForgetModal() {
      this.$refs.formValidate.resetFields();
      this.showForgetTip = true;
    },
    // 重置验证码
    resetCode() {
      this.imgTime = new Date().getTime();
    },
    yz() {
      if (this.formInline.account == '') {
        this.$notice.msg('请输入您的账号！');
        return;
      }
      if (this.formInline.password == '') {
        this.$notice.msg('请输入您的密码！');
        return;
      }
      if (this.formInline.code == '') {
        this.$notice.msg('请输入验证码！');
        return;
      }
      this.loading = true;
      this.formInline.loginType = 2; //1 运营   2转介人或者业务员
      this.formInline.loginMode = 1;
      this.$http({
        url: '/system/info/validateCode',
        type: 'post',
        forced: 1,
        data: this.formInline
      })
        .then(res => {
          this.loading = false;
          this.phoneCode = '';
          if (res.httpCode == 1) {
            // 短信校验
            this.bindPhoneNumber = res.data.mobile;
            this.showPhoneValid = true;
          } else {
            this.resetCode();
            this.loading = false;
            this.$notice.error(res.msg);
          }
        })
        .catch(err => {
          this.loading = false;
        });
    },
    timerStart() {
      this.count = 60;
      window.clearInterval(this.timer);
      this.timerStartFun();
      this.timer = window.setInterval(this.timerStartFun, 1000);
    },
    timerStartFun() {
      this.count--;
      this.codeText = "重新发送" + "（" + this.count + "s）";
      if (this.count <= 0) {
        window.clearInterval(this.timer);
        this.codeText = "获取验证码";
        return;
      }
    },
    getCode() {
      if (this.codeText != '获取验证码') {
        return;
      }
      if (this.bindPhoneNumber) {
        this.phoneNumber = this.bindPhoneNumber;
      }
      if (!this.bindPhoneNumber && !this.$regulars.isPhone(this.phoneNumber)) {
        this.$notice.error('请输入正确的手机号');
        return;
      }
      this.loading = true;
      let url, params;
      let account = this.formInline.account;
      // 如果是ie转码
      if (!!window.ActiveXObject || 'ActiveXObject' in window) {
        account = encodeURIComponent(account);
      }
      if (this.bindPhoneNumber) {
        //已绑定手机号，发送登录验证码
        url = '/system/info/sendLoginCode';
        params = {
          account: account,
          code: this.formInline.code,
          password: this.formInline.password
        };
      } else {
        //未绑定手机号,发送绑定验证码
        url = '/system/info/sendMobileBindSms';
        params = {
          mobile: this.phoneNumber
        };
      }
      this.timerStart();
      this.$http({
        type: 'POST',
        url: url,
        data: params
      })
        .then(res => {
          this.loading = false;
          if (res.httpCode == 1) {
            this.$notice.success('验证码发送成功');
          }
        })
        .catch(e => {
          window.clearInterval(this.timer);
          this.codeText = "获取验证码";
          this.loading = false;
        });
    },
    phoneCodeLogin() {
      if (this.bindPhoneNumber) {
        //已绑定手机号
        this.phoneNumber = this.bindPhoneNumber;
      }
      let account = this.formInline.account;
      // 如果是ie转码
      if (!!window.ActiveXObject || 'ActiveXObject' in window) {
        account = encodeURIComponent(account);
      }
      if (!this.phoneCode) {
        this.$notice.msg('请输入短信验证码');
        return;
      }
      if (this.phoneCode.length != 6) {
        this.$notice.msg('请输入6位短信验证码');
        return;
      }
      this.login();
    },
    login() {
      this.loading = true;
      let account = this.formInline.account;
      // 如果是ie转码
      if (!!window.ActiveXObject || 'ActiveXObject' in window) {
        account = encodeURIComponent(account);
      }
      this.$http({
        type: 'POST',
        url: `/system/userLogin`,
        query: {
          account: account,
          password: this.formInline.password
        },
        data: {
          account: account,
          password: this.formInline.password,
          loginType: 2, //1 运营   2转介人 3业务员
          loginMode: 1,
          code: this.formInline.code,
          smsCode: this.phoneCode
        },
        forced: 1
      })
        .then(data => {
          this.loading = false;
          if (data.httpCode == 1) {
            localStorage.setItem('hasLogin', true);
            this.$router.replace('/');
          } else {
            this.$notice.error(data.msg);
          }
        })
        .catch(err => {
          this.loading = false;
          this.$notice.error('账号或者密码不正确！');
        });
    }
  },
  destroyed() {
    window.clearInterval(this.timer);
    clearInterval(this.codeTimer);
    this.codeTimer = null;
    this.timeTxt = '重新发送';
  }
};
</script>
<style lang="scss" scoped>
@import './login.scss';
</style>
